import { useSelector } from 'react-redux';
import oddsTransformer from '../oddsTransformer';
import { getEffectiveOddsMultiplier } from '../utils';

const _oddsTransformer = oddsTransformer();

const useOddTransformer = () => {
  const customerCustomOddsMultiplier = useSelector(
    (state) => state.auth.userLimits?.customOddsMultiplier
  );

  const transform = (isLive, isOutRights, marketNumericId, sportEventStartTime, odds, marketStringId) => {
    const effectiveMultiplier = getEffectiveOddsMultiplier(customerCustomOddsMultiplier, marketStringId);
    const customOdds = effectiveMultiplier * odds;

    return _oddsTransformer.transform(
      new Date(),
      isLive,
      isOutRights,
      marketNumericId,
      sportEventStartTime,
      customOdds
    );
  };

  const transformWithDisplayFormatted = (
    isLive,
    isOutRights,
    marketNumericId,
    sportEventStartTime,
    odds,
    marketStringId
  ) => {
    const transformed = transform(isLive, isOutRights, marketNumericId, sportEventStartTime, odds, marketStringId);

    if (transformed >= 100) {
      return transformed.toFixed(0);
    }

    return transformed > 10 ? transformed.toFixed(1) : transformed.toFixed(2);
  };

  return { transform, transformWithDisplayFormatted };
};

export default useOddTransformer;
